/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Footer_CnaInputs */

const en_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const ar_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const de_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const es_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const fr_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const it_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const ja_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const ko_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const pt_br_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const ru_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const th_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const tr_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No auto-renewal. You can extend your membership anytime.`)
};

const zh_cn_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到期后不会自动续费，可随时购买延长效期。`)
};

const zh_tw_onboarding_paywall_footer_cna = /** @type {(inputs: Onboarding_Paywall_Footer_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到期后不会自动续费，可随时购买延长效期。`)
};

/**
* | output |
* | --- |
* | "No auto-renewal. You can extend your membership anytime." |
*
* @param {Onboarding_Paywall_Footer_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_footer_cna = /** @type {((inputs?: Onboarding_Paywall_Footer_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Footer_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_footer_cna(inputs)
	if (locale === "ar") return ar_onboarding_paywall_footer_cna(inputs)
	if (locale === "de") return de_onboarding_paywall_footer_cna(inputs)
	if (locale === "es") return es_onboarding_paywall_footer_cna(inputs)
	if (locale === "fr") return fr_onboarding_paywall_footer_cna(inputs)
	if (locale === "it") return it_onboarding_paywall_footer_cna(inputs)
	if (locale === "ja") return ja_onboarding_paywall_footer_cna(inputs)
	if (locale === "ko") return ko_onboarding_paywall_footer_cna(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_footer_cna(inputs)
	if (locale === "ru") return ru_onboarding_paywall_footer_cna(inputs)
	if (locale === "th") return th_onboarding_paywall_footer_cna(inputs)
	if (locale === "tr") return tr_onboarding_paywall_footer_cna(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_footer_cna(inputs)
	return zh_tw_onboarding_paywall_footer_cna(inputs)
});